import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const RefRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (code) {
      // 保存邀请码到 localStorage，确保用户返回首页后再注册也能记录关系
      localStorage.setItem('referrer_code', code);
      // 重定向到注册页面，带上邀请码
      navigate(`/register?ref=${code}`, { replace: true });
    } else {
      // 没有邀请码，跳转到首页
      navigate('/', { replace: true });
    }
  }, [code, navigate]);

  return null;
};

export default RefRedirect;
